function QuoteSection() {

    return (
        <section>
            <div className="quote-section">
                <div className="quote-mark">"</div>
                <div className="quote">The privilege of a lifetime is to become who you truly are</div>
                <div className="sig">Carl Jung</div>
            </div>
        </section>
    );
}

export default QuoteSection;